import { PaymentOrdersState } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialPaymentOrdersState: PaymentOrdersState = {
    outputFilename: null,
    outputXML: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
};
